/**
 * The Shelf — RPGreek's ranked catalog.
 *
 * BoardGameGeek's real gag is that its rating culture judges the CATALOG entry
 * long before anyone judges the game: weight scores as moral law, unplayed
 * titles ranked on "vibe," campaign pages reviewed instead of rulebooks. The
 * joke here is the same one Regretsit runs on moderation — the site has to
 * look like a thriving, opinionated community for the bit to land, so this
 * list is static and hand-written rather than sourced from anything real.
 */

export interface Entry {
  id: string
  rank: number
  title: string
  designer: string
  /** BGG-style complexity score, 1.00 (light) to 5.00 (heavy). */
  weight: number
  ratings: number
  shelf: string
  blurb: string
  logged?: boolean
}

export const SHELVES = ['Ranked', 'Homebrew Queue', 'Unplayed', 'Zines']

export const SHELF: Entry[] = [
  {
    id: 'e0',
    rank: 1,
    title: 'EvolveRPG',
    designer: 'Barry Dydax',
    weight: 3.8,
    ratings: 0,
    shelf: 'Unplayed',
    blurb:
      'Zero logged plays. Ranked #1 anyway — the box art has correct priorities and that is a signal, not a shortcut.',
    logged: false,
  },
  {
    id: 'e1',
    rank: 2,
    title: 'Last Ember',
    designer: 'Obsidian Studios',
    weight: 2.7,
    ratings: 41,
    shelf: 'Zines',
    blurb:
      'The only zine the studio ever finished. We do not discuss why. We do discuss the stapling.',
  },
  {
    id: 'e2',
    rank: 3,
    title: 'Ledger of Quiet Kings',
    designer: 'Priya Nunez Design Collective',
    weight: 4.1,
    ratings: 812,
    shelf: 'Ranked',
    blurb: 'A 4.1 pretending to be a 2.7. We have all played it. We have all lied about it.',
  },
  {
    id: 'e3',
    rank: 4,
    title: 'Session Zero: Compact',
    designer: 'Vesper Quill',
    weight: 1.4,
    ratings: 2309,
    shelf: 'Ranked',
    blurb: 'Correctly credited, correctly paid, correctly rated. Suspicious.',
  },
  {
    id: 'e4',
    rank: 5,
    title: 'Thursday Knights, Unabridged',
    designer: 'Anonymous (table submission)',
    weight: 3.2,
    ratings: 6,
    shelf: 'Homebrew Queue',
    blurb: 'Six ratings, all five stars, all from the same table. We are letting it ride.',
  },
  {
    id: 'e5',
    rank: 6,
    title: 'Orbital Stretch',
    designer: 'Barry Dydax (concept)',
    weight: 2.0,
    ratings: 0,
    shelf: 'Unplayed',
    blurb: 'A stretch goal for a game that has not shipped. Logged. Weighed. Judged.',
    logged: false,
  },
]

/** Ratings are never accepted. See netlify/lib/council.ts for why. */
export const RATING_IS_DISABLED_REASON =
  'Your rating has been received into the queue ahead of the Council reviewing whether you are qualified to rate.'
